import styles from "./grid.module.css"

const gridStyles = (string) =>
  string
    .split(" ")
    .map((styleName) => styles[styleName])
    .join(" ")

export default gridStyles
